<app-titled-page heading="Solicitudes de repuestos">
  <router-outlet></router-outlet>
</app-titled-page>
